export const userSuggestionContainer = {
  overflow: "hidden",
  w: { lg: "30%" },
  maxW: { base: "468px", lg: "347px" },
  h: "fit-content",
};

export const userSuggestionMainProfile = {
  align: "center",
  columnGap: "1rem",
  p: "3",
  display: { base: "none", lg: "flex" },
};

export const allSuggestedProfileBox = {
  flexDir: { base: "row", lg: "column" },
  w: { base: "100vw", md: "auto" },
  overflow: "auto",
  maxW: "100%",
};

export const userSuggestionAllProfileBox = {
  p: "3",
  align: "center",
  flexDir: { base: "column", lg: "row" },
  minW: { base: "130px", lg: "auto" },
  rowGap: "0.5rem",
  outline: { base: "0.5px solid gray", lg: "none" },
  justifyContent: "space-between",
  cursor: "pointer",
};

// export const filterButton = {
//   display: "flex",
//   alignItems: "center",
//   gap: "0.5rem",
//   justify: "center",
//   padding: "0.3rem 0.5rem",
//   outline: "0.5px solid gray",
//   width: "fit-content",
//   margin: "0.5rem auto",
// };
